<app-page-header
  title="Home"
  titleLink="/reports"
  active_item="Reserva Financeira"
>
</app-page-header>
<form [formGroup]="extrato">
  <div class="row">
    <h5>{{ "common.ggrMovement" | translate }}</h5>
    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
              ><i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i
            ></a>
          </div>
        </div>
        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterColapsed"
        >
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slTransactionType" class="form-label">{{
                  "common.type" | translate
                }}</label>
                <ng-select
                  id="slTransactionType"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="transactionTypes"
                  bindValue="value"
                  bindLabel="name"
                  [formControl]="extrato.controls.tipo"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="inputInitialDate" class="form-label">
                  {{ "common.initialDate" | translate }}
                </label>
                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    matInput
                    [ngxMatDatetimePicker]="pickerIni"
                    placeholder="DD/MM/YYYY HH:mm"
                    [formControl]="extrato.controls.initialDate"
                  />
                  <ngx-mat-datetime-picker #pickerIni></ngx-mat-datetime-picker>
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="$any(pickerIni)"
                  ></mat-datepicker-toggle>
                </mat-form-field>
                <div
                  class="invalid-feedback d-block"
                  *ngIf="extrato.controls.initialDate.invalid && isSubmitted"
                >
                  {{ "common.initialDateRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="inputInitialDate" class="form-label">
                  {{ "common.finalDate" | translate }}
                </label>
                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    matInput
                    [ngxMatDatetimePicker]="pickerFim"
                    placeholder="DD/MM/YYYY HH:mm"
                    [formControl]="extrato.controls.endDate"
                  />
                  <ngx-mat-datetime-picker #pickerFim></ngx-mat-datetime-picker>
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="$any(pickerFim)"
                  ></mat-datepicker-toggle>
                </mat-form-field>
                <div
                  class="invalid-feedback d-block"
                  *ngIf="extrato.controls.endDate.invalid && isSubmitted"
                >
                  {{ "common.finalDateRequired" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-sm-4">
              <div class="form-group">
                <label for="slTefAccount" class="form-label">{{
                  "common.selectReserveAccount" | translate
                }}</label>
                <ng-select
                  [items]="listsAccountTef"
                  bindValue="id"
                  [formControl]="extrato.controls.tefAccount"
                  placeholder="Selecione a conta"
                  [searchable]="false"
                  [clearable]="false"
                >

                  <ng-template ng-option-tmp let-item="item">
                    {{ item.id }} ({{ item.description }})
                  </ng-template>


                  <ng-template ng-label-tmp let-item="item">
                    {{ item.id }} ({{ item.description }})
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar()"
              >
                <i class="fe fe-search me-2"></i
                >{{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-12">
      <div class="card rounded-10 shadow">
        <div class="row">
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                    "common.deposit" | translate
                  }}</span>
                  <p class="fs-15 me-3 mb-0">
                    {{ recebimento | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                    "common.depositCount" | translate
                  }}</span>
                  <p class="fs-15 me-3 mb-0">
                    {{ quantidadeDeposito }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-4 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-down"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                      "common.withdraw" | translate
                    }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">{{ saque | formatCurrency }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-4 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-down"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                      "common.withdrawalCount" | translate
                    }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">{{ quantidadeSaque }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-up text-primary"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                      "common.finalBalance" | translate
                    }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">
                    {{ saldoFinal | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">
            {{ "common.transactions" | translate }}
          </div>
          <div class="card-options">
            <button
              type="button"
              class="btn btn-pill btn-default-light"
              (click)="downloadFile()"
            >
              <i class="fe fe-download me-2"></i>Exportar
            </button>
          </div>
        </div>
        <div class="card-body button-table">
          <app-table-transactions-reserva
            [accountIdGeneric]="extrato.controls.tefAccount.value || ''"
          >
          </app-table-transactions-reserva>
        </div>
      </div>
    </div>
  </div>
</form>
